export type Theme = 'light' | 'dark';

export function getInitialTheme(
  storage?: Pick<Storage, 'getItem'>,
  media: Pick<Window, 'matchMedia'> | undefined = typeof window === 'undefined' ? undefined : window,
): Theme {
  try {
    const activeStorage = storage ?? (typeof window === 'undefined' ? undefined : window.localStorage);
    const saved = activeStorage?.getItem('theme');
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {}
  return media?.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(
  theme: Theme,
  root: HTMLElement = document.documentElement,
): void {
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
}
